export default __webpack_public_path__ + "images/pages/regimen_finder/skin_types/normal-to-dry-39552c0cd6be6b01f5fbdee4fb01a2eb.svg";